<template>
    <div>
        <video id="player-element" ref="videoPlayer" class="video-js" @timeupdate="throttledTimeChange"></video>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue'
import videojs from 'video.js';

type PlayerPropsType = {
    autoplay: boolean,
    controls: boolean,
    fluid: boolean,
    preload: string,
    html5: {
        vhs: {
            overrideNative: boolean,
            bandwidth: number,
        },
        nativeAudioTracks: boolean,
        nativeVideoTracks: boolean
    },
    sources: Array<{ src: string, type: string }>,
    height: number,
    width: number

}
export default defineComponent({
    name: 'VideojsPlayer',
    props: {
        options: {
            type: Object as () => PlayerPropsType,
            default: () => ({}),
            required: true
        },
    },
    setup(props, { emit }) {
        const isPlaying = ref<boolean>(false)
        const isSupported = ref<boolean>(false)
        const VideoJSPlayerInstance: any = ref(null)
        let lastTimeUpdate = 0
        onMounted(() => {
            VideoJSPlayerInstance.value = videojs(
                'player-element',
                props.options,
                function onPlayerReady() {
                    console.log('Player Is: ', VideoJSPlayerInstance)
                },
            )
        });
        onBeforeUnmount(() => {
            VideoJSPlayerInstance.value.dispose()
        })
        function timeChange() {
            const currentTime = VideoJSPlayerInstance.value.currentTime() * 1000;
            //console.log('Time changed: ', currentTime);
            emit('timeChange', currentTime);
        }
        function throttledTimeChange() {
            const now = Date.now()
            if (now - lastTimeUpdate >= 1000) {
                lastTimeUpdate = now
                timeChange()
            }
        }
        function seekTo(ms: number) {
            if (VideoJSPlayerInstance.value) {
                VideoJSPlayerInstance.value.currentTime(ms / 1000)
            }
        }
        return {
            throttledTimeChange,
            seekTo
        }
    },
})
</script>